import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { UIStates } from "../../core/src/ui/UIStates";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from "../../core/src/commands/CommandEnum";
import ViewManager from "../../core/src/utils/ViewManager";
import ErrorModel from  "../../core/src/model/ErrorModel";
import ReelGroup from "../../core/src/views/ReelGroup";
import { VendorCommandsEnum } from "../commands/VendorCommandsEnum";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import Configs from "../vendorConfigs/Configs";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import CommManager from "../../core/src/controllers/CommManager";

export default class ErrorState extends State {

    private errorMap:{[key: string]: string} = {
        "ERROR_57":"insufficientFunds"
    };

    private softErrorCodes: number[] = [57];

    public enter(): void {

        super.enter();
        const errorConfig = Configs.error;
        if(errorConfig.hasErrorMap()) {
            this.errorMap = errorConfig.getErrorMap();
        }

        if(errorConfig.hasSoftErrorCodes()) {
            this.softErrorCodes = errorConfig.getSoftErrorCodes();
        }
        
        let errCodeFormat = Number(ErrorModel.errorCode);
        let softError = false;

        this.softErrorCodes.forEach( excludeCode => {
            if(excludeCode === errCodeFormat) {
                softError = true;
            }
        });

        if (!softError && RequestRegister.has("sendError")) {
            CommManager.send(RequestRegister.get("sendError"), () => {}, this, null, false, false);
        }
        
        ViewManager.getLayer("SplashOverlay").setScene("open");
        UIController.setState(UIStates.ERROR);

        if(softError) {  // soft error
            this.determineError(errCodeFormat);
        } else {  // hard error
            this.showError();
        }
    }

    private determineError(code: number) {
        switch (this.errorMap["ERROR_" + code]) {

            case "insufficientFunds":
                this.insufficientError();
                break;
                
            default:
            this.showError();
                break;
        }
    }

    private showError() {
        CommManager.disableComm();
        CommandManager.execute(Commands.SHOW_ERROR, () => {
            location.reload();
        });
    }

    protected insufficientError() {

        if (AutoplayModel.isAutoSpinActive()) {
            CommandManager.execute(Commands.STOP_AUTOPLAY);
        }

        CommandManager.execute(
            VendorCommandsEnum.SHOW_INSUFFICIENT_FUNDS_MESSAGE,
            () => { this.exit(); }
        );
    }

    public exit(): void {
        ErrorModel.cleanUp();
        ViewManager.getLayer("SplashOverlay").clear();
        ReelGroup.instance?.stopDefault();
        super.exit();
    }
}